<div class="wrapper">
    <div class="content">
        <div class="alert alert-danger">
            The page you are trying to access is not available on mobile devices or you do not have access to it.
        </div>
    </div>
</div>
